
import { defuFn } from '/home/forge/app.eis-s.de/releases/20241106093900/client/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}

import cfg0 from "/home/forge/app.eis-s.de/releases/20241106093900/client/nuxt-core/app.config.ts"

export default /* #__PURE__ */ defuFn(cfg0, inlineConfig)
